import { render, staticRenderFns } from "./CancelTechnicianInvite.vue?vue&type=template&id=6700be4b"
import script from "./CancelTechnicianInvite.vue?vue&type=script&lang=js"
export * from "./CancelTechnicianInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports